<template>
  <f7-page name="radioaktivita-chart" @page:init="onPageInit">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>{{ pageTitle }}</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
        <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>

    <template v-if="notEmptyObject(stationDataForChart)">

      <highcharts ref="raHighcharts" :updateArgs="[true, true, true]" :options="chartOptions"></highcharts>

    </template>

  </f7-page>
</template>
<script>
import Axios from "axios";
import SHMUconf from "../js/SHMUconf";
import {Chart} from 'highcharts-vue'
import Highcharts from 'highcharts';

import pChart from './radioaktivita-chart-options'

Highcharts.setOptions({
  lang: {
    weekdays: ['Nedeľa','Pondelok', 'Utorok', 'Streda', 'Štvrtok', 'Piatok', 'Sobota'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'Máj', 'Jún', 'Júl', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
    months: ['Január', 'Február', 'Marec', 'Apríl', 'Máj', 'Jún', 'Júl', 'August', 'September', 'Október', 'November', 'December']
  },
  global: {
    useUTC: false
  }
});


export default {
  components: {
    highcharts: Chart
  },
  data: function () {
    return {
      pageTitle: 'Rádioaktivita',
      stationIdForChart: null,
      stationDataForChart: {},
      chartOptions: pChart,
    };
  },
  watch: {
    stationDataForChart() {
      if (this.notEmptyObject(this.stationDataForChart)) {
        this.generateChart();
      }
    }
  },
  mounted() {
    const self = this;
    // otvorime hlavne menu
    this.$f7.accordion.close('.shmu-i-pocasie');
    this.$f7.accordion.open('.shmu-i-pocasie');
  },
  destroy() {
    clearInterval(this.tCheckInterval);
    this.stationIdForChart = null;
    this.stationDataForChart = {};
  },
  methods: {
    onPageInit() {
      this.stationIdForChart = this.$f7route.params.station_id;
      this.pageReload(null, true);
    },
    pageReload(event, isInit) {
      const self = this;

      if (this.stationIdForChart && (isInit || (this.$moment().unix() - this.lastUpdated) > 60)) {
        this.loadHistoryData(this.stationIdForChart);
      } else {
        if (!this.stationIdForChart) {
          self.$f7.dialog.alert('Identifikátor stanice nebol správne určený!', 'Nastala chyba');
        }
      }
    },
    loadHistoryData(station_id) {
      const self = this;

      self.$f7.dialog.preloader('Načítavam...');
      Axios.get(SHMUconf.API_BASE_URL + 'meteo/getradiationdata?station='+station_id+'&history=720', {
        crossDomain: true,
        cache: false,
      })
          .then((response) => {
            if (!response.data.error) {
              self.stationDataForChart = response.data;
              self.pageTitle = self.stationDataForChart.station.station_name + ' - Rádioaktivita';
              self.lastUpdated = self.$moment().unix();
              // clearInterval(this.tCheckInterval);
              // this.tCheckInterval = setInterval(this.checkLastUpdated, 5 * 60 * 1000); // overujem kazdych 5 min
            } else {
              self.$f7.dialog.alert('Nepodarilo sa načítať údaje pre vykreslenie grafu', 'Nastala chyba');
            }
            self.$f7.dialog.close();
          }).catch((error) => {
        self.$f7.dialog.close();
        self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
      });

    },
    checkLastUpdated() {
      if ((this.$moment().unix() - this.lastUpdated) >= 5*60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
        this.pageReload(null, false);
      }
    },
    generateChart() {
      // priprav data pre chart
      let vals = [];
      let r_vals = [];
      if (this.stationDataForChart.data.length > 0) {
        this.stationDataForChart.data.forEach((item) => {

          let m_f = this.$moment.unix(item.dt).tz('Europe/Bratislava').utc().format();
          let m = this.$moment(m_f);
          let d = Date.UTC(m.year(), m.month(), m.date(), m.hours(), m.minutes(), m.seconds());

          vals.push([d, item.value]);
          if (item.value > 0) {
            r_vals.push(item.value);
          }
        });
      }

      var max = r_vals.reduce(function(a, b) {
        return Math.max(a, b);
      });

      if (max < 400) max = 450;
      else max = max*1.2;
      this.chartOptions.yAxis.max = max;

      let z = this.chartOptions.series.find(item => (item.id) === 'm_radiacia');
      z.data = vals;
      z.name = this.stationDataForChart.station.station_name + '<br>Hodnota radiácie [nSv/h] za posledných 30 dní'

    },


  }

};
</script>

